import KartuStockMaterial from "./KartuStockMaterial"

export default KartuStockMaterial